module.exports = __webpack_public_path__ + "static/media/Image-5.5d45d021.jpg";